import PublishingDetailSection from '../../../sections/AdminDashboard/Configuration/PublishingDetail';

const PublishingDetail = () => <PublishingDetailSection />;

export default PublishingDetail;
